import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { Hero } from '../../components/Hero';
import { FiltersTabsContainer } from '../FiltersTabsContainer';
import { FiltersContainer } from '../FiltersContainer';
import { SearchStringBlockContainer } from '../SearchStringBlockContainer/SearchStringBlockContainer';
import { selectSeoData } from '../../selectors/seoData';
import { selectPageSection } from '../../selectors/pageSection';
import { ESectionType } from '../../types/sectionType';

export const HeroContainer: React.FC = () => {
  const seoData = useSelector(selectSeoData);
  const section = useSelector(selectPageSection);
  const isChildrenDayEnabled = useSelector((state: IApplicationState) => state.features.isChildrenDayEnabled);

  const filtersBlock =
    section === ESectionType.Index ? (
      <SearchStringBlockContainer />
    ) : (
      <>
        <FiltersTabsContainer />
        <FiltersContainer />
      </>
    );

  return (
    <Hero
      title={seoData?.h1 || ''}
      isDobroshriftEnabled={false}
      isChildrenDayEnabled={isChildrenDayEnabled}
      filtersBlock={filtersBlock}
      isRedesignEnabled={section === ESectionType.Index}
    />
  );
};
